import { object, string } from 'yup';
import { transformNullToUndefined } from '../../form-schemas/Schema.utils';

const MutateProcessorMatchCandidateSchema = object().shape({
    user_selected_processor_id: string().optional().transform(transformNullToUndefined),
});

export default MutateProcessorMatchCandidateSchema;
